<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-11 15:00:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-07-30 12:07:43
 * @FilePath:
 * @Description: 扫码取号之后展示的卡牌二维码及消费金额详情页面
-->
<template>
  <div class="electronicHand">
    <div class="electronicHandCode" v-if="hasHandCodeInfo">
      <div class="electronicHandContainer">
        <div class="content-top">
          <div class="codeTit">
            <span> 消费识别二维码 </span>
            <i>绑定时间：{{ cardInfo.BindTime }}</i>
          </div>
          <div class="codeImage">
            <vue-qr :text="cardInfo.QCode"></vue-qr>
            <!-- <img :src="electronicImage" alt=""> -->
          </div>
        </div>
        <div class="content-bottom">
          <div class="electronicHandNews">
            <div class="news">
              <p>{{ cardInfo.TableCode }}</p>
              <i>手牌号</i>
            </div>
            <div class="news">
              <p>{{ cardInfo.Duration }}<i>分钟</i></p>
              <i>在店时长</i>
            </div>
            <div class="news">
              <p>
                ￥<span> {{ cardInfo.CheckingOutAmount }}</span>
              </p>
              <i>消费金额</i>
            </div>
          </div>
          <!-- <router-link tag="a"
          :to="{ name: 'SelfCheckoutPay', params: { TableCode:  cardInfo.TableCode } }"
          v-if="cardInfo.CheckingOutAmount ">
            查看明细
          </router-link> -->
          <div class="customTips">
            <p v-for="(item, index) in cardInfo.ElectricKeyTips" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
      </div>
      <div class="electronicHandBottom">结账离场后，手牌将与微信自动解绑！</div>
    </div>
    <div v-else class="no_handcard_con">
      <van-empty :description="handCodeTips" />
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import { getScanTakeNumberInfo } from "@/api/scan";
import { handleSessionStorage } from "@/utils";
export default {
  name: "ConsumeCodeInfo",
  props: {},
  data() {
    return {
      hasHandCodeInfo: false,
      handCodeTips: "",
      cardInfo: {
        BindTime: "",
        TableCode: "",
        QCode: "",
        CheckingOutAmount: 0,
        ElectricKeyTips: [],
      },
    };
  },
  components: {
    VueQr,
  },
  created() {
    this.handleGetNumberInfo();
  },
  mounted() {},
  methods: {
    handleGetNumberInfo() {
      let vpnInfoCode = this.$store.state.vpnInfo.code;
      if(!vpnInfoCode){
         vpnInfoCode =handleSessionStorage.get("ScanResultVpnCode")
      }
      getScanTakeNumberInfo({ vpnCode: vpnInfoCode }).then((res) => {
        if (typeof res == "string") {
          this.hasHandCodeInfo = false;
          this.handCodeTips = res;
        } else {
          if (!res.TableCode) {
            this.hasHandCodeInfo = false;
            this.handCodeTips = "手牌分配中，请稍后...";
            this.handleGetNumberInfo();
          } else {
            this.cardInfo = {
              ...res,
              ElectricKeyTips: res.ElectricKeyTips?.split("\\r\\n"),
            };
            this.hasHandCodeInfo = true;
          }
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.electronicHand {
  min-height: 100vh;
  position: relative;
  text-align: center;
  .electronicHandCode {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: var(--tc);
    .electronicHandContainer {
      width: 682px;
      height: 1036px;
      margin: 34px 34px 20px 34px;
      border-radius: 20px;
      overflow: hidden;
      .content-top {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 60px;
        background: #ffffff;
        box-shadow: 0px 16px 20px 0px rgba(131, 134, 163, 0.12);
        > .codeTit {
          position: relative;
          display: flex;
          flex-flow: column wrap;
          margin-bottom: 20px;
          padding-left: 26px;
          text-align: left;
          box-sizing: border-box;
          &::after {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;
            content: "";
            width: 120px;
            height: 106px;
            background: url("../../assets/images/fuhao.png") no-repeat center;
            background-size: 100%;
            opacity: 0.3;
          }
          > span {
            position: relative;
            z-index: 2;
            margin-top: 64px;
            line-height: 56px;
            font-size: 40px;
            font-weight: 600;
            color: #000;
          }
          > i {
            line-height: 36px;
            font-size: 26px;
            color: #666;
          }
        }
        > .codeImage {
          width: 260px;
          height: 260px;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .content-bottom {
        position: relative;
        background: #f6f7f8;
        height: 556px;
        overflow: hidden;
        &::before {
          position: absolute;
          left: -15px;
          top: 50px;
          z-index: 1;
          content: "";
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: var(--tc);
        }
        &::after {
          position: absolute;
          right: -15px;
          top: 50px;
          z-index: 1;
          content: "";
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: var(--tc);
        }
        .electronicHandNews {
          width: 100%;
          height: 100px;
          margin-top: 70px;
          margin-bottom: 50px;
          display: flex;
          display: -webkit-flex;
          align-items: center;
          justify-content: space-around;
          .news {
            flex: 1;
            color: #292621;
            font-size: 48px;
            border-right: 1px solid #d2d2d2;
            > p {
              height: 60px;
              display: flex;
              display: -webkit-flex;
              align-items: center;
              justify-content: center;
              margin: 0 0 0 4px;
              > span {
                font-size: 60px;
                margin-left: -8px;
              }
              > i {
                color: #646464;
                font-size: 30px;
              }
            }
            > i {
              color: #646464;
              font-size: 24px;
              margin-top: 24px;
            }
          }
          .news:last-child {
            border-right: none;
          }
        }
        > a {
          color: var(--tc);
          font-size: 24px;
        }
        .customTips {
          width: 90%;
          margin: 20px auto;
          text-align: center;
          line-height: 1.5;
          font-size: 30px;
          color: #999;
        }
      }
    }
    .electronicHandBottom {
      width: 100%;
      font-size: 24px;
      color: #fff;
      margin-top: 36px;
      padding-bottom: 53px;
      box-sizing: border-box;
    }
  }
  .no_handcard_con {
    padding-top: 45%;
  }
}
</style>
